import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import App from './App.tsx'
import { config } from './libs/sentry/sentry-config.ts'

// Sentry初期化（ローカルは明示デバッグ時のみ送信）
import('@sentry/react').then(({ init, captureException }) => {
  if (config.dsn) {
    init(config)
  }

  // 簡易E2E検証用：`?sentry-test=1` でテストイベント送信
  const searchParams = new URLSearchParams(window.location.search)
  const isSelfTest =
    searchParams.get('sentry-test') === '1' ||
    import.meta.env.VITE_SENTRY_DEBUG === '1'
  if (isSelfTest) {
    setTimeout(() => {
      console.error('Sentry E2E test for console error')
      captureException(new Error('Sentry E2E test for captureException'))
    }, 0)
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
